import { gsap } from 'gsap';
import { getElementFromEvent } from '../utils';

export default class Menu {
	constructor() {
		document.addEventListener('bless', (e) => {
			this.replaceMenus(e);
			this.init();
			this.closeMenu();
		});
	}

	init() {

		this.header = document.querySelector('[data-header]');
		this.hamburger = this.header.querySelector('[data-hamburger]');
		this.navContainer = this.header.querySelector('[data-mainnav-container]');
		this.menu = this.header.querySelector('[data-menu]');

		this.mainMenu = this.header.querySelector('[data-menu-list]');
		this.menuItems = this.menu.querySelectorAll('[data-menu-item]'); //has submenu

		if (!this.menuItems) {
			return;
		}

		this.menuOpen = false;

		this.hamburger.addEventListener('click', (e) => {
			this.toggleMenu();
		});

		this.breakpoint = window.matchMedia('(max-width:992px)');

		if (this.breakpoint.matches) {

			// Mobile
			this.mainMenu.addEventListener('click', (e) => {
				const button = getElementFromEvent(e, '[data-dropdown-toggle]');

				if (!button) {
					return;
				}

				const parent = button.closest('[data-menu-item]');

				this.menuItems.forEach((element) => {
					const dropdown = element.querySelector('.c-main-nav__dropdown-wrapper');

					if (parent == element) {
						if (parent.classList.contains('is-active')) {
							element.classList.remove('is-active');
							dropdown.style.height = 0;
						} else {
							element.classList.add('is-active');
							dropdown.style.height = dropdown.scrollHeight + 32 + 'px';
						}
					} else {
						element.classList.remove('is-active');
						dropdown.style.height = 0;
					}
				});
			});
		} else {

			// Desktop
			this.expandedItem = null;

			this.menuItems.forEach((item) => {
				const button = item.querySelector('button');

				button.addEventListener('click', (event) => {

					if (button.ariaExpanded === 'false') {
						this.expandSubMenu(item);
					} else {
						this.collapseSubMenu(item);
					}
				});

				item.addEventListener('mouseenter', () => {
					this.expandSubMenu(item);
				});
				item.addEventListener('mouseleave', () => {
					this.collapseSubMenu(item);
				});

				// Handling keyboard navigation
				button.addEventListener('keydown', (event) => {
					if (event.key === 'Enter' || event.key === ' ') { // Space or Enter key
						event.preventDefault(); // Prevent the default action to stop scrolling when pressing Space
						if (button.ariaExpanded === 'false') {
							this.expandSubMenu(item);
						} else {
							this.collapseSubMenu(item);
						}
					}
				});

				// Handling tab key inside submenu to loop back to the button
				const subMenuLinks = item.querySelectorAll('ul a');
				if (subMenuLinks.length) {
					const lastLink = subMenuLinks[subMenuLinks.length - 1];
					lastLink.addEventListener('keydown', (event) => {
						if (event.key === 'Tab' && !event.shiftKey) {
							event.preventDefault();
							button.focus(); // Move focus back to the button
						}
					});
				}
		  	});
		}
	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		if (this.menuOpen) {
			return;
		}

		this.menuOpen = true;

		// ScrollLock Disable
		document.dispatchEvent(new CustomEvent('disable-scroll', {
			detail: {
				scrollingElm: this.navContainer,
			}
		}));

		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);

		gsap.set(this.navContainer, {
			visibility: 'visible',
		});

		const tl = gsap.timeline({
			ease: 'sine.inOut',
			duration: 0.2,
		});

		if (this.breakpoint.matches === true) {
			tl.to(this.navContainer, {
				xPercent: -100,
				ease: 'back.out(1)',
				duration: 0.4,
			});
		}

		window.addEventListener('keydown', e => {

			if (e.key === 'Escape') {
				if(this.menuOpen){
					this.closeMenu();
				}
			}
		});
	}

	closeMenu() {

		this.menuOpen = false;

		if (this.breakpoint.matches === true) {

			this.navContainer.classList.remove('is-open');
			this.hamburger.classList.remove('is-active');

			const tl = gsap.timeline({
				ease: 'sine.inOut',
				duration: 0.2,
				onComplete: () => {

					gsap.set(this.navContainer, {
						visibility: 'hidden',
					});

					// ScrollLock Enable
					document.dispatchEvent(new CustomEvent('enable-scroll'));

					this.hamburger.setAttribute('aria-expanded', false);
					this.hamburger.focus();
				},
			});


			tl.to(this.navContainer, {
				xPercent: 0,
				duration: 0.4,
			});
		} else {
			this.menuItems.forEach((item) => {
				const button = item.querySelector('[data-dropdown-toggle]');
				button?.setAttribute('aria-expanded', false);
				this.header.classList.remove('has-expanded-menu');
			});
		}
	}

	expandSubMenu(item) {

		console.log(item);

		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = null;
		}

		const subMenu = item.querySelector('.c-main-nav__dropdown-wrapper');

		if(!subMenu) {
			return;
		}

		const button = item.querySelector('[data-dropdown-toggle]');
		this.expandedItem = item;

		this.header.classList.add('has-expanded-menu');

		subMenu.setAttribute('aria-hidden','false');
		button.setAttribute('aria-expanded','true');
		item.dataset.expanded = 'true';
		subMenu.querySelectorAll('a')[0].focus(); // Focus on the first link in the submenu
	}

	collapseSubMenu(item) {
		const subMenu = item.querySelector('.c-main-nav__dropdown-wrapper');

		if(!subMenu) {
			return;
		}

		const button = item.querySelector('[data-dropdown-toggle]');
		this.expandedItem = null;

		this.timer = setTimeout(() => {
			this.header.classList.remove('has-expanded-menu');
		}, 300);

		subMenu.setAttribute('aria-hidden','true');
		button.setAttribute('aria-expanded','false');
		item.dataset.expanded = 'false';
	}

	replaceMenus(e) {
		const barbaMenu = e.target.querySelector('[data-barba-menu]');

		const barbaMenuLeft = barbaMenu.querySelector('[data-home-link]');
		const mainLogo = document.querySelector('[data-logo]');
		mainLogo.innerHTML = '';
		mainLogo.appendChild(barbaMenuLeft);

		const barbaMenuCenter = barbaMenu.querySelector('[data-menu]');
		const menu = document.querySelector('[data-mainnav-container]');
		menu.innerHTML = '';
		menu.appendChild(barbaMenuCenter);

		const barbaMenuSide = barbaMenu.querySelector('[data-side-menu]');

		const sideMenu = document.querySelector('[data-sidenav-container]');
		sideMenu.innerHTML = '';
		sideMenu.appendChild(barbaMenuSide);
	}
}
